import React from "react";
import * as S from "./styles.js";

const CTAButton = ({
  text = undefined,
  id,
  name,
  onClick,
  light,
  dark,
  small,
  rounded,
  outlined,
  ...props
}) => {
  return (
    <S.Button
      {...props}
      id={id}
      name={name}
      onClick={onClick}
      light={light}
      dark={dark}
      small={small}
      rounded={rounded}
      outlined={outlined}
    >
      {text}
    </S.Button>
  );
};

export default CTAButton;
